define(["require", "exports", "tslib", "lodash.debounce", "mobx", "mobx-react", "react", "../model/domain", "../model/entity/DashboardParameters", "../model/services/EventManager", "../model/services/SrmsServiceManager", "../store/RouteStore", "../store/StoreManager", "./blocks", "./blocks/DataTable/DataTable"], function (require, exports, tslib_1, lodash_debounce_1, mobx_1, mobx_react_1, React, domain_1, DashboardParameters_1, EventManager_1, SrmsServiceManager_1, RouteStore_1, StoreManager_1, blocks_1, DataTable_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DashboardView = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    React = tslib_1.__importStar(React);
    let DashboardView = exports.DashboardView = class DashboardView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "watcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "changeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onFilterChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (change) => {
                    this.loadEntityData();
                }
            });
            Object.defineProperty(this, "refresh", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.loadEntityData();
                }
            });
            Object.defineProperty(this, "openEntity", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (entity) => {
                    const open = (path, entityId) => {
                        (0, RouteStore_1.openRoute)({ pathname: `/${path}/${entityId}` });
                    };
                    if (entity.Type === domain_1.PermitTypeDomain.findByKey(domain_1.PermitTypeDomain.TravelPermit).value) {
                        open("tp/0", entity.Id);
                    }
                    else if (entity.Type === domain_1.PermitTypeDomain.findByKey(domain_1.PermitTypeDomain.GrazingPermit).value) {
                        open("gp/0", entity.Id);
                    }
                    else if (entity.Type === domain_1.PermitTypeDomain.findByKey(domain_1.PermitTypeDomain.HarvestingPermit).value) {
                        open("hp/0", entity.Id);
                    }
                    else if (entity.Type === domain_1.PermitTypeDomain.findByKey(domain_1.PermitTypeDomain.GrazingAuthority).value) {
                        open("ga/0", entity.Id);
                    }
                    else if (entity.Type === "Water Agreement") {
                        open("wa/0", entity.Id);
                    }
                    else if (entity.Type === "SRN Change Request") {
                        open("scr/0", entity.Id);
                    }
                    else if (entity.Type === "Facility Inspection" || entity.Type === "Facility Inspection (Stocktake)") {
                        open("f/0/i", entity.Id);
                    }
                    else if (entity.Type === "Facility Works Project") {
                        open("f/0/wp", entity.Id);
                    }
                    else if (entity.Type === "Progress Report") {
                        open("f/0/wp", `${entity.Id}/pr/${entity.SubTypeId}`);
                    }
                }
            });
            const p = new DashboardParameters_1.DashboardParameters();
            p.IncludePermits = true;
            p.IncludeWaterAgreements = true;
            p.IncludeSrnCr = true;
            p.IncludeFacilityInsp = true;
            p.IncludeFacilityWorksProjects = true;
            p.IncludeFacilityWpPr = true;
            this.state = {
                data: [],
                p
            };
        }
        componentDidMount() {
            this.changeBatchFn = (0, lodash_debounce_1.default)(this.onFilterChange, 1500);
            this.watcher = (0, mobx_1.observe)(this.state.p, this.changeBatchFn);
            this.loadEntityData();
        }
        componentWillUnmount() {
            this.watcher && this.watcher();
        }
        loadEntityData() {
            (0, EventManager_1.notify)("Loading Outstanding Tasks");
            SrmsServiceManager_1.SrmsServiceManager.Instance.Common.getEntityDataForDashboard(this.state.p.toJson()).then(res => {
                this.setState({
                    p: this.state.p,
                    data: res
                });
            });
        }
        render() {
            const rowData = this.state.data;
            const columns = [
                {
                    Header: "Id",
                    accessor: "RefId",
                    minWidth: 180,
                    Cell: (props) => {
                        return React.createElement(DataTable_1.LinkCell, Object.assign({}, props, { column: "RefId", onClick: this.openEntity }));
                    }
                },
                {
                    Header: "Type",
                    accessor: "Type",
                    minWidth: 180,
                    Cell: (props) => {
                        return React.createElement(DataTable_1.TextCell, Object.assign({}, props, { column: "Type" }));
                    }
                },
                {
                    Header: "Create Date",
                    accessor: "CreateDate",
                    minWidth: 100,
                    Cell: (props) => {
                        return React.createElement(DataTable_1.DateCell, Object.assign({}, props, { column: "CreateDate" }));
                    }
                },
                {
                    Header: "Status",
                    accessor: "Status",
                    minWidth: 170,
                    Cell: (props) => {
                        return React.createElement(DataTable_1.TextCell, Object.assign({}, props, { column: "Status" }));
                    }
                },
                {
                    Header: "Lga",
                    accessor: "Lga",
                    minWidth: 220,
                    Cell: (props) => {
                        return React.createElement(DataTable_1.TextCell, Object.assign({}, props, { column: "Lga" }));
                    }
                }
            ];
            return (React.createElement(blocks_1.VGroup, null,
                React.createElement(blocks_1.Header, { title: "Dashboard" },
                    React.createElement(blocks_1.HeaderButton, { label: "Refresh", onClick: this.refresh })),
                React.createElement(blocks_1.VGroup, { style: { padding: "12px" } },
                    React.createElement(DataTable_1.DataTable, { data: rowData, columns: columns }),
                    React.createElement(blocks_1.VGroup, { className: "form" },
                        React.createElement("h1", null, "Data Filters"),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include Permits", propertyOwner: this.state.p, propertyName: "IncludePermits", hideLabel: true, label: "Include Permits" }),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include Water Agreements", propertyOwner: this.state.p, propertyName: "IncludeWaterAgreements", hideLabel: true, label: "Include Water Agreements" }),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include SRN Change Requests", propertyOwner: this.state.p, propertyName: "IncludeSrnCr", hideLabel: true, label: "Include SRN Change Requests" }),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include Facility Inspections", propertyOwner: this.state.p, propertyName: "IncludeFacilityInsp", hideLabel: true, label: "Include Facility Inspections" }),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include Facility Works Projects", propertyOwner: this.state.p, propertyName: "IncludeFacilityWorksProjects", hideLabel: true, label: "Include Facility Works Projects" }),
                        React.createElement(blocks_1.CheckBoxField, { id: "Include Facility Works Project Progress Reports", propertyOwner: this.state.p, propertyName: "IncludeFacilityWpPr", hideLabel: true, label: "Include Facility Works Project Progress Reports" })))));
        }
    };
    exports.DashboardView = DashboardView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], DashboardView);
});
